import { defineComponent as _defineComponent } from 'vue';
import { useWorkflowInstance } from "@/composables/useWorkflowInstance";
import ParameterStep from "./ParameterStep.vue";
import WorkflowInvocationStep from "./WorkflowInvocationStep.vue";
import GenericHistoryItem from "components/History/Content/GenericItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowInvocationDetails',
    props: {
        invocation: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const { workflow } = useWorkflowInstance(props.invocation.workflow_id);
        function dataInputStepLabel(key, input) {
            const invocationStep = props.invocation.steps[key];
            let label = invocationStep && invocationStep.workflow_step_label;
            if (!label) {
                if (input.src === "hda" || input.src === "ldda") {
                    label = "Input dataset";
                }
                else if (input.src === "hdca") {
                    label = "Input dataset collection";
                }
            }
            return label;
        }
        return { __sfc: true, props, workflow, dataInputStepLabel, ParameterStep, WorkflowInvocationStep, GenericHistoryItem };
    }
});
